document.addEventListener('DOMContentLoaded', function() {
    const list = document.querySelector('.related-products__list');
    const items = document.querySelectorAll('.related-products__item');
    const prevBtn = document.querySelector('.swiper-controls__button--prev');
    const nextBtn = document.querySelector('.swiper-controls__button--next');
    let currentIndex = 0;
    
    function updateSlider() {
        const width = list.offsetWidth;
        list.style.transform = `translateX(-${currentIndex * width}px)`;
        
        prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
        nextBtn.style.opacity = currentIndex === items.length - 1 ? '0.5' : '1';
        prevBtn.style.cursor = currentIndex === 0 ? 'default' : 'pointer';
        nextBtn.style.cursor = currentIndex === items.length - 1 ? 'default' : 'pointer';
    }

    prevBtn.addEventListener('click', function() {
        if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
        }
    });

    nextBtn.addEventListener('click', function() {
        if (currentIndex < items.length - 1) {
            currentIndex++;
            updateSlider();
        }
    });

    window.addEventListener('resize', updateSlider);
    
    updateSlider();
});